import { render, staticRenderFns } from "./pl5.vue?vue&type=template&id=493b1d3f&scoped=true"
var script = {}
import style0 from "./pl5.vue?vue&type=style&index=0&id=493b1d3f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493b1d3f",
  null
  
)

export default component.exports